/* LMP 28-10-2026: affichage client en Dhs sans décimales. Montants de paiement et SEO inchangés. */
(function () {
  'use strict';
  var nf = new Intl.NumberFormat('fr-MA', { maximumFractionDigits: 0, useGrouping: true });
  var currencyPattern = /(?:\bMAD\s*)?(\d{1,3}(?:[ .\u00a0\u202f]\d{3})*(?:[.,]\d{1,2})?|\d+(?:[.,]\d{1,2})?)\s*(?:MAD|DHS?|د\.م\.)\b/gi;
  function parseAmount(s) {
    var n = s.replace(/[\s\u00a0\u202f]/g, '');
    if (n.indexOf(',') !== -1) n = n.replace(/\./g, '').replace(',', '.');
    else if (/^\d{1,3}(\.\d{3})+$/.test(n)) n = n.replace(/\./g, '');
    var result = Number(n);
    return Number.isFinite(result) ? result : null;
  }
  function transform(s) {
    return s.replace(currencyPattern, function (full, raw) {
      var n = parseAmount(raw);
      return n === null ? full : nf.format(Math.round(n)) + ' Dhs';
    }).replace(/\bMAD\b/g, 'Dhs');
  }
  function convert(root) {
    if (!root || root.nodeType !== 1 || /^(SCRIPT|STYLE|NOSCRIPT|TEXTAREA|TEMPLATE|SVG)$/.test(root.tagName)) return;
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode: function(node) {
        if (!node.nodeValue || !/MAD|\bDhs?\b|د\.م\./i.test(node.nodeValue)) return NodeFilter.FILTER_REJECT;
        var parent = node.parentElement;
        if (!parent || parent.closest('script,style,noscript,textarea,template,svg,[contenteditable="true"]')) return NodeFilter.FILTER_REJECT;
        return NodeFilter.FILTER_ACCEPT;
      }
    });
    var changed = [], node;
    while ((node = walker.nextNode())) {
      var updated = transform(node.nodeValue);
      if (updated !== node.nodeValue) changed.push([node, updated]);
    }
    changed.forEach(function(pair) { pair[0].nodeValue = pair[1]; });
  }
  function start() {
    convert(document.body);
    var pending = new Set(), queued = false;
    var observer = new MutationObserver(function(mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var m = mutations[i];
        if (m.type === 'characterData' && m.target.parentElement) pending.add(m.target.parentElement);
        else if (m.type === 'childList') m.addedNodes.forEach(function(n){ if (n.nodeType === 1) pending.add(n); else if (n.parentElement) pending.add(n.parentElement); });
      }
      if (!queued && pending.size) {
        queued = true;
        requestAnimationFrame(function() {
          queued = false;
          var items = Array.from(pending);
          pending.clear();
          items.forEach(convert);
        });
      }
    });
    observer.observe(document.body, { childList: true, characterData: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once:true });
  else start();
})();
